import { NgModule, Type } from '@angular/core';
import { CplaceControlComponent } from '../components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export abstract class CfControlPlugin<T extends CplaceControlComponent<any>> {
  public abstract readonly component: Type<T>;
  public abstract readonly module: Type<NgModule>;
}
